module.exports = __webpack_public_path__ + "static/media/aerial-shot-basketball-court-color.198f3cd5.png";